import { render } from "./g-form.vue?vue&type=template&id=907aa07e&scoped=true"
import script from "./g-form.vue?vue&type=script&lang=js"
export * from "./g-form.vue?vue&type=script&lang=js"

import "./g-form.vue?vue&type=style&index=0&id=907aa07e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907aa07e"]])

export default __exports__